import templateUrl from "webutils/panel.htm";
import "webutils/panel-simple.htm";

export default {
  bindings: {
    collapsed: "=?",
    title: "@panelTitle",
    maxHeight: "@panelMaxHeight",
    preventCollapse: "<?",
    initiallyCollapsed: "@",
    icon: "@",
    type: "@",
    raw: "@"
  },
  transclude: {
    header: "?panelHeader",
    //title: '?panelTitle',
    body: "?panelBody",
    raw: "?panelRaw",
    footer: "?panelFooter"
  },
  templateUrl($element, $attrs) {
    const layout = /*$attrs.type ||*/ $attrs.layout;
    return $attrs.templateUrl
      ? $attrs.templateUrl
      : layout
      ? `panel-${layout}.htm`
      : templateUrl;
  },
  controller($transclude) {
    this.isSlotFilled = slot => $transclude.isSlotFilled(slot);
    if (!this.type) this.type = "default";
    if (!this.maxPanelHeight) this.maxPanelHeight = "350px";
    if (this.initiallyCollapsed === "true") this.collapsed = true;
  }
};
